export default {
  log_out: 'Wyloguj się',
  empty_list_part1: 'Jeżeli nie widzisz tu żadnych materiałów, kliknij w',
  empty_list_part2: ', a następnie zaloguj się ponownie do Early Stage ONLINE.',
  music_app_info_heading: 'Chcesz więcej informacji o&nbsp;Aplikacji muzycznej?',
  music_app_info_cta: 'Przejdź do',
  music_app_info_link_label: 'instrukcji Early Stage MUSIC',
};
